import { GET_PRODUCTS_REQUEST, GET_PRODUCTS_LOADED } from "../../constants";
import { createAction } from "../../utils";

const setProductsLoading = createAction(GET_PRODUCTS_REQUEST);
const setProductsLoaded = createAction(GET_PRODUCTS_LOADED);

// "Dummy action" to access the API:
export const getHostingPlanPrice = (hostingPlanId) => {
  return async (dispatch, getState, { api }) => {
    dispatch(setProductsLoading());
    const hostingPlanPrice = await api.getHostingPlanPrice(hostingPlanId);
    dispatch(setProductsLoaded());
    return hostingPlanPrice;
  };
};
